import { Field } from "formik";
import { TextField } from "formik-mui";
import React from "react";
import Mark from "../../../assets/svg/mark.svg";
import useUploadImage from "../../../hooks/useUploadImage";
import useUploadMultiple from "../../../hooks/useUploadMultiple";
import SelectInput from "../../SelectInput";

const Form2 = ({ values, onChange, form, setUploadImage }) => {
  const options1 = ["Condo", "Duplex", "Triplex", "Apartment"];
  const options2 = ["Rent", "Own", "Lease to own", "other"];
  const { images, removeAll } = useUploadMultiple("contents");
  const { handleClick, onChange: handleChange, imageRef, image } = useUploadImage();

  const handleInputChange = (value, name) => {
    onChange(name, value);
  };

  return (
    <>
      <p className="text-[#131221] font-black text-[16px] md:text-[22px] self-start w-[350px]">Add Home/Building Details</p>
      <div className="w-full flex flex-col items-center justify-center ">
        <div className="pt-6 w-full flex flex-col md:w-[335px]">
          <p className="font-semibold self-start pb-4">Upload Property Images before Disaster</p>
          <label htmlFor="imageUpload" onClick={handleClick}>
            <div className="flex flex-col text-[#ACACAC] h-[73px] gap-1 px-6 py-[20px] rounded-xl items-center justify-center border-dashed border-primary border-[1.4px]">
              {image.preview?.length === 0 ? (
                <p className="text-[14px] text-jumbleng-gray">
                  <i className="fa-solid fa-circle-plus mr-1 "></i>
                  Add Photo
                </p>
              ) : (
                <p className="text-[14px] text-jumbleng-gray">{image.preview?.length} images selected</p>
              )}
            </div>
          </label>
          <input
            id="imageUpload"
            type="file"
            accept="image/*"
            className="w-0.1 h-0.1 overflow-hidden hidden"
            multiple
            ref={imageRef}
            onChange={(event) => {
              setUploadImage(event.target.files);
              handleChange(event, true);
            }}
          />
          {images.length > 0 && (
            <button onClick={removeAll} className="text-primary mt-1 self-end">
              Remove all images
            </button>
          )}
        </div>
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"propertyName"}
              label="Your Property Name"
              value={values.propertyName || ""}
              placeholder="312 Quilly Lane Worthington"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>
        <div className="pt-6">
          <SelectInput
            options={options1}
            handleChange={(e) => handleInputChange(e, "propertyType")}
            label={"Property Type"}
            minWidth={"md:w-[335px]"}
            name={"propertyType"}
            data={form.propertyType}
          />
        </div>
        <div className="pt-6">
          <SelectInput
            options={options2}
            handleChange={(e) => handleInputChange(e, "ownershipType")}
            label={"Ownership Type"}
            minWidth={"md:w-[335px]"}
            name={"ownershipType"}
            data={form.ownershipType}
          />
        </div>{" "}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"propertySize"}
              label="Property Size in Sq Ft"
              placeholder="Property Size in Sq Ft"
              value={values.propertySize || ""}
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>{" "}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"totalBedrooms"}
              label="Total Bedrooms"
              placeholder="Total Bedrooms"
              value={values.totalBedrooms || ""}
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>{" "}
        {/* <div className="pt-6">
          <SelectInput
            options={options3}
            handleChange={(e) => handleInputChange(e, "totalBedrooms")}
            label={"Total Bedrooms"}
            minWidth={"md:w-[335px]"}
            name={"totalBedrooms"}
            data={form.totalBedrooms}
          />
        </div>{" "} */}
        {/* <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"livingRoomSize"}
              label="Size of Living Room"
              value={values.livingRoomSize || ""}
              placeholder="Size of Living Room"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div> */}
        {/* <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"kitchenSize"}
              label="Size of Kitchen"
              value={values.kitchenSize || ""}
              placeholder="Size of Kitchen"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div> */}
        {/* <div className="pt-6">
          <SelectInput
            options={options3}
            handleChange={(e) => handleInputChange(e, "totalBathrooms")}
            label={"Total Bathrooms"}
            minWidth={"md:w-[335px]"}
            name={"totalBathrooms"}
            data={form.totalBathrooms}
          />
        </div> */}
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"totalBathrooms"}
              label="Total Bathrooms"
              value={values.totalBathrooms || ""}
              placeholder="Total Bathrooms"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>
        <div className="pt-6">
          <div className="mt-1 relative flex md:justify-end">
            <Field
              name={"propertyPrice"}
              label="Property Price"
              value={values.propertyPrice || ""}
              placeholder="$250,000"
              component={TextField}
              className="border w-full md:w-[335px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
            />
            <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Form2;
